import styled, { createGlobalStyle, css, ExecutionContext } from 'styled-components';
import 'react-grid-layout/css/styles.css';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';

export type ThemedStyledProps<P> = P & ExecutionContext;

export const CommonStyle = createGlobalStyle`
    .no-padding-grid {
      padding-right: 0;
      padding-left: 0;
    }

    .ant-select {
        z-index: 999;
    }
`;

type AnimationProps = {
    $animationStyle: React.CSSProperties;
};

export const StyledAnimationDiv = styled.div<AnimationProps>`
    height: 100%;
    width: 100%;
    ${(props: ThemedStyledProps<AnimationProps>) => css({ ...props.$animationStyle })};
`;
